const LeadGuarantee = ({
    isEligible = false,
    maxFreeRenewalCount = 0,
    remainingFreeRenewalCount = 0,
} = {}) => ({
    isEligible: Boolean(isEligible),
    maxFreeRenewalCount: Number(maxFreeRenewalCount),
    remainingFreeRenewalCount: Number(remainingFreeRenewalCount),
});

export default LeadGuarantee;
